(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest('.mobile-facets__details > .mobile-facets__summary');
      if (summary) {
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener('menudrawer:close', function () {
    var form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    form.querySelectorAll('.mobile-facets__details.js-filter').forEach(function (details) {
      details.setAttribute('open', '');
    });
  });

  var activeHandle = null;

  function formatRangeValue(val, symbol) {
    if (val && typeof val === 'string' && val.indexOf(symbol) === 0) return val;
    var n = parseFloat(val);
    if (isNaN(n)) return val;
    if (typeof theme !== 'undefined' && theme.Currency && typeof theme.Currency.formatMoney === 'function' && theme.shopSettings && theme.shopSettings.moneyFormat) {
      return theme.Currency.formatMoney(Math.round(n * 100), theme.shopSettings.moneyFormat).replace(/\.00(?=\D|$)/, '');
    }
    var formatted = n.toLocaleString(undefined, { maximumFractionDigits: 2 });
    return symbol ? symbol + formatted : formatted;
  }
  function updateFilterCounts() {
    var form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    var checkboxCount = form.querySelectorAll('input[type="checkbox"]:checked').length;
    var priceActive = false;
    form.querySelectorAll('input[name$=".gte"], input[name$=".lte"]').forEach(function (input) {
      if (input.value !== '') priceActive = true;
    });
    var count = checkboxCount + (priceActive ? 1 : 0);

    var applyBtn = form.querySelector('.mobile-facets__apply');
    if (applyBtn) {
      var applyPrefix = applyBtn.getAttribute('data-apply-prefix') || 'Apply Filters';
      applyBtn.textContent = applyPrefix + ' (' + count + ')';
    }

    var priceLabel = form.querySelector('.mobile-facets__price-range-label');
    if (priceLabel) {
      var symbol = priceLabel.getAttribute('data-currency-symbol') || '$';
      var minLabel = priceLabel.getAttribute('data-min-label');
      var maxLabel = priceLabel.getAttribute('data-max-label');
      var gteInput = form.querySelector('input[name$=".gte"]');
      var lteInput = form.querySelector('input[name$=".lte"]');
      var gteVal = gteInput && gteInput.value !== '' ? gteInput.value : (minLabel !== null ? minLabel : '0');
      var lteVal = lteInput && lteInput.value !== '' ? lteInput.value : (maxLabel !== null ? maxLabel : '0');
      priceLabel.textContent = formatRangeValue(gteVal, symbol) + ' - ' + formatRangeValue(lteVal, symbol);
    }

    var openLabel = document.querySelector('.mobile-facets__open-label');
    if (openLabel) {
      var openCount = openLabel.querySelector('.mobile-facets__open-count');
      if (count > 0) {
        if (!openCount) {
          openCount = document.createElement('span');
          openCount.className = 'mobile-facets__open-count';
          openLabel.appendChild(openCount);
        }
        openCount.textContent = '\u00a0\u00b7\u00a0' + count;
      } else if (openCount) {
        openCount.remove();
      }
    }

    form.querySelectorAll('.mobile-facets__details.js-filter').forEach(function (details) {
      var badge = details.querySelector('.mobile-facets__count-bubble');
      var sectionCount = details.querySelectorAll('input[type="checkbox"]:checked').length;
      if (sectionCount > 0) {
        if (badge) {
          badge.textContent = sectionCount;
        } else {
          var badgeEl = document.createElement('span');
          badgeEl.className = 'mobile-facets__count-bubble';
          badgeEl.textContent = sectionCount;
          details.querySelector('.mobile-facets__summary span').appendChild(badgeEl);
        }
      } else if (badge) {
        badge.remove();
      }
    });
  }
  document.addEventListener('collection:reloaded', updateFilterCounts);
  document.addEventListener(
    'input',
    function (event) {
      if (event.target && event.target.closest('#FacetFiltersFormMobile')) updateFilterCounts();
    },
    true
  );

  function touchToMouse(event, offsetX) {
    var touch = event.touches[0];
    var mouseEvent = new MouseEvent(event.type === 'touchmove' ? 'mousemove' : 'mousedown', {
      clientX: touch.clientX,
      clientY: touch.clientY,
      bubbles: true
    });
    if (offsetX !== undefined) {
      Object.defineProperty(mouseEvent, 'offsetX', { value: offsetX });
    }
    return mouseEvent;
  }

  function onTouchStart(event) {
    var track = event.target.closest('.mobile-facets .price-range__track-wrapper');
    if (!track) return;
    var touch = event.touches[0];
    var handles = track.querySelectorAll('.price-range__thumbs');
    var nearest = null;
    var minDist = Infinity;
    handles.forEach(function (handle) {
      var rect = handle.getBoundingClientRect();
      var dist = Math.hypot(touch.clientX - (rect.left + rect.width / 2), touch.clientY - (rect.top + rect.height / 2));
      if (dist < minDist) {
        minDist = dist;
        nearest = handle;
      }
    });
    if (!nearest || minDist > 28) return;
    activeHandle = nearest;
    var thumbRect = nearest.getBoundingClientRect();
    var offsetX = Math.max(0, Math.min(touch.clientX - thumbRect.left, thumbRect.width));
    nearest.dispatchEvent(touchToMouse(event, offsetX));
  }

  function onTouchMove(event) {
    if (!activeHandle) return;
    event.preventDefault();
    window.dispatchEvent(touchToMouse(event));
    updateFilterCounts();
  }

  function onTouchEnd() {
    if (!activeHandle) return;
    activeHandle = null;
    window.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
  }

  window.addEventListener('touchstart', onTouchStart, { passive: true });
  window.addEventListener('touchmove', onTouchMove, { passive: false });
  window.addEventListener('touchend', onTouchEnd);
  window.addEventListener('touchcancel', onTouchEnd);
})();


(function () {
  'use strict';

  var drawerDetails = document.querySelector('.mobile-facets__wrapper > details');
  if (!drawerDetails) return;

  new MutationObserver(function () {
    var beacon = document.getElementById('loyaltylion-beacon-frame');
    if (!beacon) return;

    beacon.style.display = drawerDetails.hasAttribute('open') ? 'none' : '';
  }).observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
})();

